import request from "@/utils/request";

export function uploadImg(file) {
  return request({
    url: "/BO/FileManage/UploadSingleFile",
    method: "post",
    params: file
  });
}

export function fetchFileList(ids) {
  return request({
    url: "/BO/FileManage/GetListByIds",
    method: "get",
    params: { ids }
  });
}

export function uploadChunkFile(file) {
  return request({
    url: "/BO/FileManage/UploadChunkFile",
    method: "post",
    params: file
  });
}
